import React, { useCallback } from 'react';
import {
  Identifier,
  useDelete,
  useNotify,
  useRecordContext,
  useRefresh,
  useResourceContext,
} from 'react-admin';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { RemoveCircleOutline } from '@mui/icons-material';

import useDialogStatus from '../../hooks/useDialogStatus';

const DeleteComment = ({
  parentId,
}: {
  parentId: Identifier;
}) => {
  const { open, openDialog, closeDialog } = useDialogStatus();

  const [deleteOne] = useDelete();
  const record = useRecordContext();
  const resource = useResourceContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const onClickDeleteComment = useCallback(() => {
    if (!record) return;
    deleteOne(
      resource,
      {
        id: `${parentId}/comment/${record._id}`,
      },
      {
        onSuccess: () => {
          closeDialog();
          refresh();
        },
        onError: () => {
          notify('Could not delete comment', { type: 'error' });
        },
      },
    );
  }, [closeDialog, deleteOne, notify, parentId, record, refresh, resource]);

  return (
    <>
      <Dialog open={open} onClose={closeDialog} fullWidth>
        <DialogTitle fontWeight="bold">Delete comment</DialogTitle>
        <DialogContent>
          <Box display="flex" gap={1}>
            <Typography>Are you sure you want to delete this comment?</Typography>
            <Typography>This action is irreversible.</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={onClickDeleteComment} variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>
      <IconButton onClick={openDialog}>
        <RemoveCircleOutline />
      </IconButton>
    </>
  );
};

export default DeleteComment;
